export const OG_IMAGE = 'https://withjoy.com/assets/public/marcom-prod/common/link-preview/home.png?opt=default&ver=2';
